<template>
    <section>
        <div class="page-wrap">
            <div class="container">
                <div class="box-content stories">
                    <h2 class="crossline-title text-center">Featured Stories</h2>
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Submit your story to be featured here!</h3>
                        </div>
                    </div>
                    <share-story hr="above"></share-story>
                </div>
            </div>
        </div>
    </section>
</template>

<script type="text/jsx">
    import ShareStory from '@/components/ShareStory.vue';
    export default {
        name: 'stories',
        components: {
            'share-story': ShareStory
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// Stories.vue?5d0663aa